import request from '../../axios';
import {IGetSummerySupplierInfo} from './types';

export const getSummerySupplierInfo = async () => {
  const {data}: {data: IGetSummerySupplierInfo} = await request.get(
    `/api/profile/summary-supplier-profile-info`,
  );

  return data;
};
